function fixTwitterEmbedsNotLoadingOnMobile() {
  const embedWrappers = document.querySelectorAll( '.wp-block-embed__wrapper' );

  if (embedWrappers && window.innerWidth < 600) {
    [...embedWrappers].forEach( item => {
      item.style.width = "100%";
    } );
  }
}

export default {
  init() {
    window.addEventListener( "load", (event) => {
      fixTwitterEmbedsNotLoadingOnMobile();
    } );
  },
};

